import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { getUsageRun, getUsageRuns, getUsageSummary } from "../api/usageTracking";
import type { UsageRunFilters } from "../types";

const STALE_MS = 60_000;

export const useUsageSummary = (days: number) =>
  useQuery({
    queryKey: ["usage-tracking", "summary", days],
    queryFn: () => getUsageSummary(days),
    staleTime: STALE_MS,
  });

export const useUsageRuns = (filters: UsageRunFilters) =>
  useQuery({
    queryKey: ["usage-tracking", "runs", filters],
    queryFn: () => getUsageRuns(filters),
    staleTime: STALE_MS,
    placeholderData: keepPreviousData,
  });

export const useUsageRun = (runId: string | null) =>
  useQuery({
    queryKey: ["usage-tracking", "run", runId],
    queryFn: () => getUsageRun(runId!),
    enabled: !!runId,
    staleTime: STALE_MS,
  });
